define(["require", "exports", "tslib", "mobx", "../../store/UserStore", "../domain"], function (require, exports, tslib_1, mobx_1, UserStore_1, domain_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrApproval = void 0;
    class SrCrApproval {
        constructor(cr) {
            Object.defineProperty(this, "cr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusPreWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsApproveEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApproveDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "CanUserCaptureApprovalComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsRefuseEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefuseDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsCancelEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CancelDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            (0, mobx_1.makeObservable)(this);
            this.cr = cr;
            this.evaluateStatus();
            this.statusWatcher = (0, mobx_1.observe)(this.cr, "ChangeStatus", x => {
                this.evaluateStatus();
            });
            this.statusPreWatcher = (0, mobx_1.observe)(this.cr, "ChangeStatusPrev", x => {
                this.evaluateStatus();
            });
        }
        evaluateStatus() {
            this.deriveApproveState();
            this.deriveCancelState();
            this.deriveRefuseState();
        }
        get ActiveStatus() {
            if (this.cr.ChangeStatusReq) {
                return this.cr.ChangeStatusReq;
            }
            else {
                return this.cr.ChangeStatus;
            }
        }
        get IsPendingOrCertified() {
            return this.ActiveStatus == domain_1.SrCrStatusDomain.Submitted
                || this.ActiveStatus == domain_1.SrCrStatusDomain.EndorsedForConsultation
                || this.ActiveStatus == domain_1.SrCrStatusDomain.ReleasedForConsultation
                || this.ActiveStatus == domain_1.SrCrStatusDomain.ConsultationApproved
                || this.ActiveStatus == domain_1.SrCrStatusDomain.Certified;
        }
        approve() {
            switch (this.cr.ChangeStatus) {
                case domain_1.SrCrStatusDomain.Draft:
                    this.setStatus(domain_1.SrCrStatusDomain.Submitted);
                    break;
                case domain_1.SrCrStatusDomain.Submitted:
                    this.setStatus(domain_1.SrCrStatusDomain.EndorsedForConsultation);
                    break;
                case domain_1.SrCrStatusDomain.EndorsedForConsultation:
                    this.setStatus(domain_1.SrCrStatusDomain.ReleasedForConsultation);
                    break;
                case domain_1.SrCrStatusDomain.ReleasedForConsultation:
                    this.setStatus(domain_1.SrCrStatusDomain.ConsultationApproved);
                    break;
                case domain_1.SrCrStatusDomain.ConsultationApproved:
                    this.setStatus(domain_1.SrCrStatusDomain.Certified);
                    break;
                case domain_1.SrCrStatusDomain.Certified:
                    throw new Error("Can not promote a Change Request that is in an Certified state");
                case domain_1.SrCrStatusDomain.Cancelled:
                    throw new Error("Can not promote a Change Request that is in a Cancelled state");
                case domain_1.SrCrStatusDomain.SubmissionRejected:
                    throw new Error("Can not promote a Change Request that is in a SubmissionRejected state");
                case domain_1.SrCrStatusDomain.ReleaseForConsultationRejected:
                    throw new Error("Can not promote a Change Request that is in a ReleaseForConsultationRejected state");
                case domain_1.SrCrStatusDomain.ConsultationRejected:
                    throw new Error("Can not promote a Change Request that is in a ConsultationRejected state");
                case domain_1.SrCrStatusDomain.CertificationRejected:
                    throw new Error("Can not promote a Change Request that is in a CertificationRejected state");
                default:
                    throw new Error("Unknown Change Request Status");
            }
            this.evaluateStatus();
        }
        reject() {
            if (this.cr.ChangeStatus == domain_1.SrCrStatusDomain.Draft) {
                this.setStatus(domain_1.SrCrStatusDomain.Cancelled);
            }
            else if (this.cr.ChangeStatus == domain_1.SrCrStatusDomain.Submitted) {
                this.setStatus(domain_1.SrCrStatusDomain.SubmissionRejected);
            }
            else if (this.cr.ChangeStatus == domain_1.SrCrStatusDomain.EndorsedForConsultation) {
                this.setStatus(domain_1.SrCrStatusDomain.ReleaseForConsultationRejected);
            }
            else if (this.cr.ChangeStatus == domain_1.SrCrStatusDomain.ReleasedForConsultation) {
                this.setStatus(domain_1.SrCrStatusDomain.ConsultationRejected);
            }
            else if (this.cr.ChangeStatus == domain_1.SrCrStatusDomain.ConsultationApproved) {
                this.setStatus(domain_1.SrCrStatusDomain.CertificationRejected);
            }
            else {
                throw new Error(`A Change Request with a status of ${this.cr.ChangeStatus} can not be refused.`);
            }
            this.evaluateStatus();
        }
        cancel() {
            if (this.cr.ChangeStatus == domain_1.SrCrStatusDomain.Draft
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.Submitted
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.EndorsedForConsultation
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.ReleasedForConsultation
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.ConsultationApproved
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.Certified
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.SubmissionRejected
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.ReleaseForConsultationRejected
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.ConsultationRejected
                || this.cr.ChangeStatus == domain_1.SrCrStatusDomain.CertificationRejected) {
                this.setStatus(domain_1.SrCrStatusDomain.Cancelled);
            }
            else {
                throw new Error(`A Change Request with a status of ${this.cr.ChangeStatus} can not be cancelled.`);
            }
            this.evaluateStatus();
        }
        deriveApproveState() {
            if (this.cr && this.cr.IsUserPriviledgedToEdit) {
                switch (this.cr.ChangeStatus) {
                    case domain_1.SrCrStatusDomain.Draft:
                        this.ApproveDesc = "Submit for endorsement";
                        this.IsApproveEnabled = true;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.SrCrStatusDomain.Submitted:
                        this.ApproveDesc = "Endorse for Consultation";
                        this.CanUserCaptureApprovalComment = true;
                        this.IsApproveEnabled = (0, UserStore_1.isUserStateGovAdminOfficer)();
                        break;
                    case domain_1.SrCrStatusDomain.EndorsedForConsultation:
                        this.ApproveDesc = "Release for Consultation";
                        this.CanUserCaptureApprovalComment = true;
                        this.IsApproveEnabled = (0, UserStore_1.isUserStateGovAdminOfficer)();
                        break;
                    case domain_1.SrCrStatusDomain.ReleasedForConsultation:
                        this.ApproveDesc = "Approve Consultation";
                        this.CanUserCaptureApprovalComment = true;
                        this.IsApproveEnabled = (0, UserStore_1.isUserStateGovAdminOfficer)();
                        break;
                    case domain_1.SrCrStatusDomain.ConsultationApproved:
                        this.ApproveDesc = "Certify";
                        this.CanUserCaptureApprovalComment = true;
                        this.IsApproveEnabled = (0, UserStore_1.isUserStateGovAdminOfficer)();
                        break;
                    case domain_1.SrCrStatusDomain.Certified:
                        this.ApproveDesc = "Certified";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.SrCrStatusDomain.Cancelled:
                        this.ApproveDesc = "Cancelled";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.SrCrStatusDomain.SubmissionRejected:
                        this.ApproveDesc = "Submission Rejected";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.SrCrStatusDomain.ReleaseForConsultationRejected:
                        this.ApproveDesc = "Release for Consultation Rejected";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.SrCrStatusDomain.ConsultationRejected:
                        this.ApproveDesc = "Consultation Rejected";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.SrCrStatusDomain.CertificationRejected:
                        this.ApproveDesc = "Certification Refused";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    default:
                        throw new Error("Unknown Status");
                }
            }
            else {
                this.IsApproveEnabled = false;
                this.CanUserCaptureApprovalComment = false;
            }
        }
        deriveRefuseState() {
            this.RefuseDesc = "Reject";
            if (this.cr && this.cr.IsUserPriviledgedToEdit) {
                switch (this.cr.ChangeStatus) {
                    case domain_1.SrCrStatusDomain.Draft:
                        this.IsRefuseEnabled = false;
                        break;
                    case domain_1.SrCrStatusDomain.Submitted:
                    case domain_1.SrCrStatusDomain.EndorsedForConsultation:
                    case domain_1.SrCrStatusDomain.ReleasedForConsultation:
                    case domain_1.SrCrStatusDomain.ConsultationApproved:
                        this.IsRefuseEnabled = (0, UserStore_1.isUserStateGovAdminOfficer)();
                        break;
                    default:
                        this.IsRefuseEnabled = false;
                }
            }
            else {
                this.IsRefuseEnabled = false;
            }
        }
        deriveCancelState() {
            this.CancelDesc = "Cancel";
            if (this.cr && this.cr.IsUserPriviledgedToEdit) {
                switch (this.cr.ChangeStatus) {
                    case domain_1.SrCrStatusDomain.Draft:
                        this.IsCancelEnabled = true;
                        break;
                    case domain_1.SrCrStatusDomain.Submitted:
                        this.IsCancelEnabled = true;
                        break;
                    case domain_1.SrCrStatusDomain.EndorsedForConsultation:
                    case domain_1.SrCrStatusDomain.ReleasedForConsultation:
                    case domain_1.SrCrStatusDomain.ConsultationApproved:
                    case domain_1.SrCrStatusDomain.SubmissionRejected:
                    case domain_1.SrCrStatusDomain.ReleaseForConsultationRejected:
                    case domain_1.SrCrStatusDomain.ConsultationRejected:
                    case domain_1.SrCrStatusDomain.CertificationRejected:
                        this.IsCancelEnabled = (0, UserStore_1.isUserStateGovAdminOfficer)();
                        break;
                    default:
                        this.IsCancelEnabled = false;
                }
            }
            else {
                this.IsCancelEnabled = false;
            }
        }
        restoreToOriginalStatus() {
            this.cr.ChangeStatusReq = null;
            this.evaluateStatus();
        }
        setStatus(status) {
            this.cr.ChangeStatusReq = status;
        }
    }
    exports.SrCrApproval = SrCrApproval;
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApproval.prototype, "IsApproveEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApproval.prototype, "ApproveDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApproval.prototype, "CanUserCaptureApprovalComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApproval.prototype, "IsRefuseEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApproval.prototype, "RefuseDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApproval.prototype, "IsCancelEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApproval.prototype, "CancelDesc", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCrApproval.prototype, "ActiveStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrApproval.prototype, "restoreToOriginalStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrApproval.prototype, "setStatus", null);
});
